import { render, staticRenderFns } from "./adjustment-batch-allocate.vue?vue&type=template&id=2d690e3d&scoped=true"
import script from "./adjustment-batch-allocate.vue?vue&type=script&lang=ts"
export * from "./adjustment-batch-allocate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d690e3d",
  null
  
)

export default component.exports